import Showcase from "../../Components/Showcase/Showcase";
import RouteLine from "../../Components/Track/RouteLine";
import ServiceGraphic from "../../Components/ServiceGraphics/ServiceGraphic";
import { SERVICES } from "../../content/services";

/** The seven services on the shared scroll-driven Showcase. */
const ServiceShowcase = () => (
  <Showcase
    label="Our services"
    endSuffix="↺"
    items={SERVICES.map((s) => ({
      id: s.id,
      title: s.name,
      visual: <ServiceGraphic id={s.id} />,
      body: (
        <>
          <p className="is-showcase__text">{s.long}</p>
          <RouteLine
            label={`${s.name}: what we deliver`}
            stops={s.deliverables.map((d) => ({ label: d }))}
          />
          <p className="is-showcase__meta">
            <span className="is-showcase__meta-label">{s.toolsLabel}</span>
            {s.tools.join(" · ")}
          </p>
        </>
      ),
    }))}
  />
);

export default ServiceShowcase;
